import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoutes from "./PrivateRoutes";
import SignIn from "../Auth";
import ForgotPassword from "../ForgotPassword";
import DeleteAccount from "../Auth/DeleteAccount";
import DeleteAccountAgent from "../Auth/DeleteAccountAgent";

export default function Routers() {
  const login = localStorage.getItem("login");

  return (
    <BrowserRouter>
      <Routes>
        {/* Redirect root route based on login */}
        <Route
          path="/"
          element={
            login ? (
              <Navigate to="/dashboard" />
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Protected routes */}
        <Route path="/" element={<PrivateRoutes />}>
          <Route path="/*" element={<LayoutRoutes />} />
        </Route>

        {/* Public routes */}
        <Route path="/login" element={<SignIn />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/delete-account" element={<DeleteAccount />} />
        <Route path="/delete-account-agent" element={<DeleteAccountAgent />} />
      </Routes>
    </BrowserRouter>
  );
}